import { Swal } from 'larasnap/support';

const config = {
    toast: true,
    showConfirmButton: false,
    timer: 3500,
    width: '320',
};

const typeOptions = {
    loader: {
        didOpen: () => Swal.showLoading(),
        timer: 0,
    },
    info: {
        icon: 'info',
    },
    success: {
        icon: 'success',
    },
    warning: {
        icon: 'warning',
    },
    error: {
        icon: 'error',
    },
};

export const Toast = options => {
    if (options.type === 'loader') {
        options.message = `<h3>${options.message}</h3>`;
    }

    return Swal.fire({
        ...config,
        ...typeOptions[options.type ?? 'info'],
        title: options.message,
        ...options,
    });
};

Object.keys(typeOptions).forEach(type => {
    Toast[type] = message => Toast({ type, message });
});
